import React from 'react'
import { Table, Header } from 'semantic-ui-react'
import _ from 'lodash'
import { numFormat } from '@rededompedro/utils'

export default function TabelaExtratoResumo({ dados, form }) {

    function getSomaValor(dado) {
        let aux = null
        dado.map((x) => (
            aux += x.valor_total
        ))
        return numFormat(parseFloat(aux))
    }

    return (
        <Table color='grey' size='small' singleLine textAlign='center' compact='very'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan='5'>
                        <Header as='h5' color='grey' textAlign='right' style={{ margin: 0 }}>
                            Período de: {form.dataInicio} até {form.dataFim}
                        </Header>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Data</Table.HeaderCell>
                    <Table.HeaderCell>Nº Controle</Table.HeaderCell>
                    <Table.HeaderCell>Descrição</Table.HeaderCell>
                    <Table.HeaderCell>Valor</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {_.map(dados, ({ data_docto, n_controle, descricao, valor_total }, index) => (
                    <Table.Row key={index}>
                        <Table.Cell>{data_docto}</Table.Cell>
                        <Table.Cell>{n_controle}</Table.Cell>
                        <Table.Cell>{descricao}</Table.Cell>
                        <Table.Cell>{numFormat(valor_total)}</Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer>
                <Table.Row>
                    <Table.HeaderCell textAlign='right' colSpan='4'>
                        <Header color='blue' style={{ font: 'Ubuntu', fontSize: 18 }}>
                            Total: {getSomaValor(dados)}
                        </Header>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        </Table>
    )
}